import { render, staticRenderFns } from "./noDataEcharts.vue?vue&type=template&id=2b15d854&scoped=true"
import script from "./noDataEcharts.vue?vue&type=script&lang=js"
export * from "./noDataEcharts.vue?vue&type=script&lang=js"
import style0 from "./noDataEcharts.vue?vue&type=style&index=0&id=2b15d854&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15d854",
  null
  
)

export default component.exports